<p>
  date-point works!
</p>
